import React, { useState } from 'react';
const faqs = [{
  q: 'Is het geschikt voor Hatha en Vinyasa?',
  a: 'Ja, het systeem omvat zowel statische als dynamische sequenties, met specifieke variaties voor Hatha, Vinyasa en therapeutische yoga.'
}, {
  q: 'Krijg ik de bonussen bij de prijs van €19,90?',
  a: 'Ja, alles is inbegrepen in het pakket als je nu koopt tijdens de launch-aanbieding. De 6 exclusieve bonussen (waarde €149) zijn volledig gratis.'
}, {
  q: 'Kan ik het gebruiken als beginnende docent?',
  a: 'Absoluut. Het biedt je de structuur die vaak ontbreekt aan het begin — met progressieve sequenties van beginner- tot gevorderden-niveau en heldere pedagogische richtlijnen.'
}, {
  q: 'In welk formaat ontvang ik het materiaal?',
  a: "Hogeresolutie PDF's, geoptimaliseerd om te lezen op tablet of smartphone, of om te printen in A4-formaat om mee te nemen naar de lesruimte. Geen speciale software vereist."
}, {
  q: 'Is de betaling veilig?',
  a: 'Ja, we gebruiken 100% versleutelde en veilige betaalsystemen. We accepteren creditcards, debitcards, iDEAL en de belangrijkste Nederlandse betaalmethodes.'
}, {
  q: 'Hoe lang heb ik toegang tot het materiaal?',
  a: 'Levenslange toegang. Eenmaal gedownload is de kit 100% van jou — zonder abonnementen, zonder terugkerende betalingen, zonder vervaldatum.'
}, {
  q: 'Is er een niet-goed-geld-terug-garantie?',
  a: 'Ja, je hebt 30 dagen volledige garantie. Als het je niet overtuigt, storten we 100% van je geld terug zonder vragen en zonder ingewikkelde procedures.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-135">
      <div className="max-w-3xl mx-auto" data-id="element-136">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-137">
          Veelgestelde Vragen
        </h2>

        <div className="space-y-4 mb-16" data-id="element-138">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(168,85,247,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-139">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-140">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-141">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-142">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-72 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-143">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-144">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center relative" data-id="element-145">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-cta-green/20 blur-[80px] pointer-events-none rounded-full" aria-hidden="true" data-id="element-146"></div>
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/20" data-id="element-147">
            🚀 JA! IK WIL MIJN LESSEN NU NAAR HET VOLGENDE NIVEAU TILLEN
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-148">
            <span data-id="element-149">⚡ Directe toegang</span>
            <span data-id="element-150">•</span>
            <span data-id="element-151">🛡️ 30 dagen garantie</span>
          </p>
        </div>
      </div>
    </section>;
}